import React, { useEffect, useState } from "react";
import "./ScrollTemp.css";
import { BackArrowIcon2, BackArrowIcon3, CustomNew, SX_dashboard_left_arrow, SX_dashboard_right_arrow, TEMP_1, TEMP_2 } from "../../assets/icons";
import TemplateSkeleton from "../../Components/SkeletonLoader/TemplateSkeleton";

const items = Array.from({ length: 14 }).map((_, i) => ({
  label: `Vintage #${i + 1}`,
  url: TEMP_1,
  id: i + 1,
  tempClass: `tempClass${i + 1}`,
  labelClass: `tempcenter${i + 1}`,
}));

export default function ScrollTemp({
  templatesList,
  template,
  setTemplate,
  setTemplateId,
  setNewProjectInputModalOpen,
  allTemplateLoading,
}) {
  const [startIndex, setStartIndex] = useState(0);
  const [windowSize, setWindowSize] = useState(3);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });
  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    if (size.winWidth > 2250) {
      setWindowSize(5);
    } else if (size.winWidth > 1800) {
      setWindowSize(4);
    } else if (size.winWidth > 1500) {
      setWindowSize(4);
    } else if (size.winWidth > 1350) {
      setWindowSize(4);
    } else if (size.winWidth > 1040) {
      setWindowSize(3);
    } else {
      setWindowSize(2);
    }
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const visibleItems = items.slice(startIndex, startIndex + windowSize);
  const visibletemplatesList = templatesList?.slice(
    startIndex,
    startIndex + windowSize
  );
  const handlePrevClick = () => {
    if (visibletemplatesList && visibletemplatesList?.length > 0) {
      setStartIndex((prevStartIndex) =>
        prevStartIndex - 1 < 0
          ? templatesList?.length - windowSize
          : prevStartIndex - 1
      );
    } else {
      setStartIndex((prevStartIndex) =>
        prevStartIndex - 1 < 0 ? items.length - windowSize : prevStartIndex - 1
      );
    }
  };

  const handleNextClick = () => {
    if (visibletemplatesList && visibletemplatesList?.length > 0) {
      setStartIndex(
        (prevStartIndex) =>
          (prevStartIndex + 1) % (templatesList?.length - windowSize + 1)
      );
    } else {
      setStartIndex(
        (prevStartIndex) =>
          (prevStartIndex + 1) % (items.length - windowSize + 1)
      );
    }
  };

  const isAtStart = startIndex === 0;
  const isAtEnd = startIndex === items.length - windowSize;

  const allTemplateSkelton = () => {
    let skeletonArr = [];
    for (let i = 0; i < 14; i++) {
      skeletonArr.push(<TemplateSkeleton />);
    }
    return skeletonArr;
  };

  return (
    <div className="w-full h-full flex">
      <button
        className="text-white text-[30px] px-[1%] w-[7.5%] flex items-center justify-center"
        onClick={handlePrevClick}
        disabled={isAtStart}
      >
        {/* <i
          className="fa-solid fa-circle-arrow-left ArrowOP"
          style={{ Color: "#ffffff" }}
        ></i> */}
         <img
            className="  w-[27px]"
            src={SX_dashboard_left_arrow}
            alt=""
            style={{ cursor: "pointer" }}
          />
      </button>

      <div className="  tempScroll snap_inline">
        {/* <button src={TEMP_2} className="Custom   Syne" onClick={(e) => setNewProjectInputModalOpen(true)}>Custom</button> */}
        <div
          className=" tempScrollDiv img-container2 "
          onClick={(e) => setNewProjectInputModalOpen(true)}
        >
          <img className="h-full w-full opacityClass " src={CustomNew} alt="" />
          <h1 className=" CustomTemp">Custom Project</h1>
        </div>

        {allTemplateLoading ? allTemplateSkelton() : visibletemplatesList?.length > 0
          ? visibletemplatesList?.map((item) => (
              <div
                className=" tempScrollDiv img-container "
                key={item?.label}
                onClick={() => {
                  setTemplateId(item?.templateId);
                  setTemplate(false);
                  setNewProjectInputModalOpen(true);
                }}
              >
                <img
                  className="h-full w-full opacityClass label"
                  src={item?.ImgUrl}
                  alt={`Slide ${item?.templateId}`}
                />
                <h1 className="tempcenter">{item?.label}</h1>
              </div>
            ))
          : visibleItems?.map((item) => (
              <div
                className=" tempScrollDiv img-container "
                key={item?.label}
                onClick={() => {
                  setTemplateId(item?.id);
                  setTemplate(false);
                  setNewProjectInputModalOpen(true);
                }}
              >
                <img
                  className="h-full w-full opacityClass label"
                  src={item?.url}
                  alt={`Slide ${item?.templateId}`}
                />
                <h1 className="tempcenter">{item?.label}</h1>
              </div>
            ))}
      </div>

      <button
        className="w-[7.5%] text-[30px]  ArrowOP pr-[1.5%]   flex items-center justify-center pl-[1%]"
        onClick={handleNextClick}
        disabled={isAtEnd}
      >
         <img
            className="  w-[27px]"
            src={SX_dashboard_right_arrow}
            alt=""
            style={{ cursor: "pointer" }}
          />
        {/* <i className="fa-solid fa-circle-arrow-right ArrowOP"></i> */}
      </button>
    </div>
  );
}